import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TimeUtil } from "src/app/libs/ui/utils/time.utils";
import { IOnConfirmEmitter } from "../../../data-access/model/interfaces/hotels-results-card.interface";
import { TokenStorageService } from "src/app/core/services/token-storage.service";
import { HotelVacationMetadata } from "../../../data-access/model/interfaces/hotel-page.interfacae";
import { ActivatedRoute } from "@angular/router";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { Subject, takeUntil } from "rxjs";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ViewGoogleMapComponent } from "../view-google-map/view-google-map.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "tic-hotels-result-card",
  templateUrl: "./hotels-result-card.component.html",
  styleUrls: ["./hotels-result-card.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotelsResultCardComponent implements OnInit {
  numberOfNights!: number;
  @Output() onSelected: EventEmitter<IOnConfirmEmitter> = new EventEmitter();
  @Input() hotel: any;
  @Input() selectedSort: any;
  @Input() hotelVacationMetadata!: HotelVacationMetadata;
  uniqueRoomsCount: any = [];
  similarRoomCount: number = 0;
  images: any[] = [];
  @Input() showSelection: boolean = false;
  showMapPopup: boolean=false;
  mapUrl: SafeResourceUrl | null = null;
  constructor(private tokenStorage: TokenStorageService,private sanitizer: DomSanitizer,private dialog :MatDialog, public facadeCheckout: CheckoutFacade) {}

  ngOnInit(): void {
    this.initializeData();
  }

  private initializeData(): void {
    this.images = this.organizeImages(this.hotel.images);
    this.setNumberOfNights();
    this.uniqueRoomsCount = this.getSimilarRoomCounts(this.hotel);
    this.findSimilarRoomCount();
  }
  private setNumberOfNights(): void {
    const timeDiff = Math.abs(
      new Date(this.hotelVacationMetadata.checkIn).getTime() -
        new Date(this.hotelVacationMetadata.checkOut).getTime()
    );
    this.numberOfNights = Math.ceil(
      timeDiff / TimeUtil.convertDaysToMilliseconds(1)
    );
  }

  private findSimilarRoomCount(): void {
    const filteredArray = this.uniqueRoomsCount.filter(
      (obj: any) => obj.count > 1
    );

    if (filteredArray.length > 0) {
      this.similarRoomCount = Math.min(
        ...filteredArray.map((obj: any) => obj.count)
      );
    }
  }

  private organizeImages(images: any): { image: string; thumbImage: string }[] {
    return images?.map((image: { url: string }) => ({
      image: image.url,
      thumbImage: image.url,
    }));
  }

  private getSimilarRoomCounts(data: any): any[] {
    const roomCounts: any = {};
    const uniqueRooms: any[] = [];

    data.rooms.forEach((room: any) => {
      const roomCode = room.roomCode;
      roomCounts[roomCode] = (roomCounts[roomCode] || 0) + 1;
      if (
        !uniqueRooms.some((uniqueRoom: any) => uniqueRoom.roomCode === roomCode)
      ) {
        const uniqueRoom = { ...room, count: roomCounts[roomCode] };
        uniqueRooms.push(uniqueRoom);
      }
    });
    return uniqueRooms;
  }

  onSelectedHotel(): void {
    this.tokenStorage.saveData(
      "hotelPrice",
      (
        this.hotel.rateRange.minRate /
        this.hotelVacationMetadata?.occupancies[0].rooms
      ).toString()
    );
    this.onSelected.emit({ hotel_id: this.hotel.id });
  }


  
 ClickedOutMapPopup(event: Event) {
  const evt = event.target as HTMLButtonElement;
  if (evt.classList.contains("flight-popup")) {
    this.showMapPopup = false;
  }
}

showMapPopupHandler(){
  this.dialog.open(ViewGoogleMapComponent,{
    data: { hotel:this.hotel },
    width: '80vw',
height: '80vh',
panelClass: 'default-dialog'
  });
  return;
}

closeMapPopup() {
  this.showMapPopup = false;
}

getEmbeddedMapUrl(): SafeResourceUrl {
  if (!this.hotel || !this.hotel.address) return null;
  const addressStr = `${this.hotel?.name},${this.hotel?.address.street}, ${this.hotel?.address.city}, ${this.hotel?.address.country}`;
  const encodedAddress = encodeURIComponent(addressStr);
  const url = `https://www.google.com/maps/embed/v1/place?key=AIzaSyCpOmb-XOzjUonfcSf3ujeNM4B1_1P9yZs&q=${encodedAddress}`;
  return this.sanitizer.bypassSecurityTrustResourceUrl(url);
}  
}
